import { Box, styled, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const Container = styled(Flex)`
  justify-content: flex-start;
  padding: 16px;
  color: #4a4a4a;
  background: #fff7e5;
  border-radius: 12px;
  border: 1px solid #ffe380;
  flex-direction: column;
`;

export const Description = styled(Flex)`
  font-size: ${(props) => (props.isDesktop ? "14px" : "12px")};
  font-style: normal;
  font-weight: 400;
  line-height: ${(props) => (props.isDesktop ? "20px" : "18px")};
`;

export const Sub = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  text-decoration: underline;
  text-underline-offset: 3px;
`;